import EventsHelper from "../../_helpers/events";
import {
  onFilterElemClick,
  clearFilterDesktop,
  onFilterHeadClick,
  closeAllDropdowns,
} from "../../_helpers/filters-helper";

import {
  getMatchCards,
  updateLiveMatch,
  showLoading,
  hideLoading,
  getCompetitionName,
  getCompListString,
  renderCompetitionLogo,
  getDateString,
  openCalendar,
  closeCalendar,
  getMatchDaysData,
  convertToSlug,
  getWeeklyNavsDateRangesObj,
  getFormattedUtcOffset,
  getGlobalScheduleApiDateRange,
  getWeeklyNavDateString,
  validateParamFromDates,
  getUrlParam,
  updateFilterSearchParam,
  getCompetitionCards,
  getYearlyCompListString,
} from "./global-schedule-helpers";

import { isDesktop } from "../../_helpers/index";
import GsStickyHeaders from "./gs-sticky-headers";
import { initGsFilters } from "../../_helpers/swiperHelper";

export default class GlobalScheduleV2Page {
  filters = {};

  static yearlyMatchDaysData = null;
  static calendarYear = null;

  constructor() {
    const _this = this;
    if (!window.gsConfig) return;

    _this.stickyHeaders = new GsStickyHeaders();

    _this.weeklyNavDates = null;
    _this.weeklyNavStartDate = null;
    _this.weeklyNavEndDate = null;
    _this.gsConfig = window.gsConfig;
    _this.weeklyNavClicked = false;
    _this.hasLiveMatches = false;
    _this.isFirstLoad = true;
    _this.schedulePage = $("[js-global-schedule-v2]");
    _this.weeklyNavNext = $("[js-global-schedule-weekly-nav-next]");
    _this.weeklyNavPrev = $("[js-global-schedule-weekly-nav-prev]");
    _this.calendarSelector = ".vbw-calendar--container";
    _this.currentDate = new Date();
    _this.yearlySeason = _this.currentDate.getFullYear();
    _this.model = null;
    _this.yearlycompetitions = null;
    _this.competitionLogos = [];
    _this.rankingsData = [];
    _this.searchParamsObj = {
      fromDate: null,
      discipline: null,
      competition: null,
      gender: null,
      team: null,
      venue: null,
      pool: null,
      round: null,
      comptype: null,
    };

    _this.listedCompsWeekly = [];
    _this.listedDispWeekly = [];
    _this.listedGendersWeekly = [];
    _this.listedTeamWeekly = [];
    _this.listedPoolWeekly = [];
    _this.listedRoundWeekly = [];
    _this.listedVenueWeekly = [];

    _this.listedGendersYearly = [];
    _this.listedDisciplinesYearly = [];
    _this.listedYearsYearly = [];
    _this.listedCompTypeYearly = [];
    _this.listedMonthsYearly = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

    _this.listedCompsLive = [];
    _this.listedDispLive = [];
    _this.listedGendersLive = [];
    _this.listedTeamLive = [];
    _this.listedPoolLive = [];
    _this.listedRoundLive = [];
    _this.listedVenueLive = [];

    _this.listedCompetitionNos = "";
    _this.listedYearlyCompetitionNos = "";
    _this.liveTypes = ["matches", "beach/matches"];
    _this.templates = {
      date: $(".vbw-gs2-dates-row-template"),
      comp: $(".vbw-gs2-competition-row-template"),
      match: $(".vbw-gs2-match-detail-template"),
      volleyTeam: $(".vbw-gs2-volley-team-template"),
      beachTeam: $(".vbw-gs2-beach-team-template"),
      noMatchesFound: $(".vbw-template-no-result .vbw-gs2-result-msg"),
      noFilterMatchesFound: $(
        ".vbw-template-no-filter-result .vbw-gs2-filter-msg",
      ),
      loadingMatches: $(".vbw-template-loading"),
      loadingCompetitions: $(".vbw-template-competition-loading"),
      compFilterItem: $(".vbw-gs2-competitions-li-template"),
      yearlyStatus: $(".vbw-gs2-yearly-status-template"),
      yearlyCard: $(".vbw-gs2-yearly-competition-template"),
      noCompetitions: $(
        ".vbw-template-no-competition .vbw-gs2-competition-msg",
      ),
      rankingsCard: $(".vbw-gs2-match-rankings-template"),
    };
    _this.activeTab = null;
    _this.bptCompType = {
      "the-finals": 1,
      elite: 2,
      challenge: 3,
      future: 4,
    };
  }

  static async asyncInit() {
    await new GlobalScheduleV2Page().init();
  }

  async init() {
    const _this = this;
    const paramKeys = getUrlParam();

    _this.checkVenueSwitch();
    // Url has params in It
    if (paramKeys) {
      await _this.handleUrlParams(paramKeys);
    }
    // If page is competition Schedule page
    else if (
      window.gsConfig.volleyTournamentIDs ||
      window.gsConfig.beachTournamentIDs
    ) {
      _this.getMatchDays();
    } else {
      _this.updateWeeklyNavDates(_this.currentDate);
      await this.startGlobalScheduleDataCalls();
      _this.getCompetitionLogoData();
      _this.updateGlobalScheduleUrl();
    }

    // Event Handlers
    _this.handleEvents();

    // init filter carousel
    if (!isDesktop()) {
      $(".vbw-filter-wrap").each(function () {
        $(this).addClass("fo-carousel");
        $(this).find(".vbw-filter-container").addClass("swiper-container");
        $(this).find(".vbw-filter-wrapper").addClass("swiper-wrapper");
      });
      initGsFilters(document.querySelector("[js-gs-co-filters-carousel]"));
      initGsFilters(document.querySelector("[js-gs-ye-filters-carousel]"));
    }
  }

  checkVenueSwitch() {
    const _this = this;
    // Check for venue time switch
    _this.isVenueSwitchChecked =
      sessionStorage.getItem("venue-switch-checked") === "true";
    if (_this.isVenueSwitchChecked) {
      $(".venue-switch-input").trigger("click");
    }
  }

  async handleUrlParams(paramKeys) {
    const _this = this;
    // Url has params in It
    for (const obj in paramKeys) {
      if (paramKeys[obj]) {
        const paramValue = decodeURIComponent(paramKeys[obj]);

        if (obj === "activetab") {
          _this.pageTabsHandler(paramValue);
          _this.isFirstLoad = false;
        } else if (obj === "fromDate" && validateParamFromDates(paramKeys)) {
          _this.currentDate = new Date(paramValue);
        } else if (obj === "yearseason") {
          _this.yearlySeason = paramValue;
        } else {
          _this.filters[obj] = paramValue;
        }
      }
    }
    _this.updateWeeklyNavDates(_this.currentDate);
    await _this.startGlobalScheduleDataCalls();
    _this.getCompetitionLogoData();
  }

  async startGlobalScheduleDataCalls() {
    const _this = this;
    if (_this.gsConfig.showYearlyCompetitionsTab) {
      await Promise.all([
        _this.getMatchesData(),
        _this.getCompetitionData(_this.yearlySeason),
        _this.getMatchDays(),
      ]);
    } else {
      await Promise.all([_this.getMatchesData(), _this.getMatchDays()]);
    }
  }

  handleEvents() {
    const _this = this;
    _this.handleSchedulePageEvents(_this);

    _this.handleWeeklyNavEvents(_this);
    EventsHelper.OnGlobalScheduleWeeklyNavChange(function (e) {
      if (!e && !e.detail) return;
      const fromDate = e.detail.fromDate;
      const toDate = e.detail.toDate;
      _this.weeklyNavChangeHandler(fromDate, toDate);
    });
  }

  handleSchedulePageEvents(_this) {
    _this.schedulePage.on("click", function (e) {
      const $elem = $(e.target);
      e.stopPropagation();

      // to defer all other work until at least the next frame by queuing a task in a `requestAnimationFrame()` callback.
      requestAnimationFrame(() => {
        setTimeout(() => {
          //On weekly nav head click
          _this.handleWeeklyNavHeadClick($elem, _this);

          //On Tab click
          _this.handleTabClick($elem, _this);

          // Dropdown filter
          _this.handleDropdownFilterClick($elem, _this);

          // On filter item click
          _this.handleFilterDropdownEvents($elem, _this);

          // clear filters
          _this.handleFilterClearEvents($elem, _this);

          // On Competition filter click
          _this.handleCompetitionFilterClick($elem, _this);

          // show matches
          _this.handleShowMatchesClick($elem, _this);

          // Venue time switch click
          _this.handleVenueSwitchClick($elem, _this);

          // Ranking data show click
          _this.handleRankingsDataClick($elem, _this);
        }, 0);
      });
    });
  }

  handleVenueSwitchClick($elem, _this) {
    if ($elem.hasClass("venue-switch-input")) {
      _this.venueTimeSwitchHandler($elem.is(":checked"));
    }
  }

  handleShowMatchesClick($elem, _this) {
    if ($elem.hasClass("hide-competition-btn")) {
      const parentBody = $elem.parents(".vbw-gs2-comp-row");
      _this.showMatchCardsHandler(parentBody);
    }
  }

  handleDropdownFilterClick($elem, _this) {
    if ($elem.hasClass("filters-dropdown-head")) {
      onFilterHeadClick($elem, _this);
    } else {
      closeAllDropdowns();
    }
  }

  handleCompetitionFilterClick($elem, _this) {
    if ($elem.hasClass("vbw-gs2-competitions-li")) {
      onFilterElemClick($elem, _this, $elem.find(".vbw-comp-li-name").text());
      updateFilterSearchParam($elem, $elem.attr("value"), _this);
      _this.updateGlobalScheduleUrl();
      _this.applyFilters();
    }
  }

  handleWeeklyNavHeadClick($elem, _this) {
    if (
      $elem.hasClass("weekly-nav-head") ||
      !!$elem.parents(".vbw-gs-calendar-icon").length
    ) {
      openCalendar(
        _this.calendarSelector,
        _this.weeklyNavDates.currentRangeDates.startDate,
        _this,
      );
    }
  }

  handleTabClick($elem, _this) {
    if ($elem.hasClass("vbw-gs2-tab-li")) {
      _this.pageTabsHandler($elem.attr("data-tab"));
    }
  }

  handleFilterClearEvents($elem, _this) {
    if ($elem.hasClass("vbw-gs2-filter-close")) {
      if ($elem.parents(".vbw-yearmonth-filters--container").length) {
        $(".vbw-gs2-yearly-container").removeClass("active-month-filter");
        $(".vbw-gs2-month-head").first().hide();
      }

      clearFilterDesktop($elem, _this);
      updateFilterSearchParam($elem, null, _this);
      _this.updateGlobalScheduleUrl();
    }
  }

  handleFilterDropdownEvents($elem, _this) {
    if (!$elem.hasClass("dropdown-li")) return;

    let yearlyFilter = $elem.parents(".vbw-gs2-yearly-filters");

    onFilterElemClick($elem, _this);
    updateFilterSearchParam($elem, $elem.attr("value"), _this);
    _this.updateGlobalScheduleUrl();

    if (!yearlyFilter.length) {
      _this.applyFilters();
      return;
    }

    if ($elem.parents(".vbw-yearseason-filters--container").length) {
      _this.yearlyChangeSeason();
      return;
    }

    if ($elem.parents(".vbw-yearmonth-filters--container").length) {
      $(".vbw-gs2-month-head .vbw-gs2-month-text")
        .first()
        .text(
          _this.gsConfig.translations.monthsFull[$elem.attr("value")] +
            " " +
            _this.yearlySeason,
        );
      $(".vbw-gs2-month-head").first().show();
      $(".vbw-gs2-yearly-container").addClass("active-month-filter");
      _this.applyCompetitionFilters();
      return;
    }

    _this.applyCompetitionFilters();
  }

  handleRankingsDataClick($elem) {
    if ($elem.hasClass("show-rankings-btn")) {
      $elem.parents(".vbw-gs2-rankings-card").toggleClass("active");
    }
  }

  handleWeeklyNavEvents(_this) {
    _this.weeklyNavNext.on("click", function (e) {
      e.stopPropagation();
      const dateRange = _this.getWeeklyDateRangeFromNav(
        ".vbw-gs2-weekly-nav-next",
      );
      if (e.currentTarget.classList.contains("vbw-gs2-weekly-nav-next"))
        _this.weeklyNavClicked = true;
      EventsHelper.GlobalScheduleWeeklyNavChange(
        dateRange.fromDate,
        dateRange.toDate,
      );
    });

    _this.weeklyNavPrev.on("click", function (e) {
      e.stopPropagation();
      const dateRange = _this.getWeeklyDateRangeFromNav(
        ".vbw-gs2-weekly-nav-prev",
      );
      if (e.currentTarget.classList.contains("vbw-gs2-weekly-nav-prev"))
        _this.weeklyNavClicked = true;
      EventsHelper.GlobalScheduleWeeklyNavChange(
        dateRange.fromDate,
        dateRange.toDate,
      );
    });
  }

  venueTimeSwitchHandler(isChecked) {
    const _this = this;
    sessionStorage.setItem("venue-switch-checked", isChecked);
    _this.isVenueSwitchChecked = isChecked;
    _this.renderMatches();
  }

  pageTabsHandler(activeTab) {
    const _this = this;
    _this.activeTab = activeTab;
    $(".vbw-gs2-tab-li").each(function () {
      _this.schedulePage.removeClass($(this).attr("data-tab"));
    });

    if (activeTab === "live-tab" && _this.hasLiveMatches) {
      _this.renderAllFilters("live");
      _this.applyFilters();
      _this.schedulePage.addClass(activeTab);
    } else if (activeTab === "yearly-tab") {
      _this.renderAllYearFilters();
      _this.schedulePage.addClass("yearly-tab");
    } else {
      _this.renderAllFilters("weekly");
      _this.applyFilters();
      _this.schedulePage.addClass("weekly-tab");
    }
  }

  getWeeklyDateRangeFromNav(weeklyNavSelector) {
    const selector = $(weeklyNavSelector);
    if (!selector) return;
    const fromDateStr = selector.attr("data-weekly-from-date-full");
    const toDateStr = selector.attr("data-weekly-to-date-full");
    const fromDate = new Date(fromDateStr);
    const toDate = new Date(toDateStr);
    return { fromDate, toDate };
  }

  getMatchDays() {
    const _this = this;
    const year = window.gsConfig.year
      ? window.gsConfig.year
      : _this.currentDate.getFullYear();
    const utcOffset = getFormattedUtcOffset(
      _this.currentDate.getTimezoneOffset(),
    );
    getMatchDaysData(
      year,
      utcOffset,
      function (matchDaysData, _ref) {
        _ref.yearlyMatchDaysData = matchDaysData;

        // Load start date/End date if schedule belongs to competition page
        if (
          window.gsConfig.volleyTournamentIDs ||
          window.gsConfig.beachTournamentIDs
        ) {
          let tournamentStartDate = _ref.currentDate;

          if (
            !!matchDaysData &&
            !!matchDaysData.matchDays &&
            matchDaysData.matchDays?.length > 0
          ) {
            if (_ref.currentDate < new Date(matchDaysData.matchDays[0])) {
              tournamentStartDate = new Date(matchDaysData?.matchDays[0]);
            } else if (
              _ref.currentDate >
              new Date(
                matchDaysData.matchDays[matchDaysData.matchDays.length - 1],
              )
            ) {
              tournamentStartDate = new Date(
                matchDaysData?.matchDays[matchDaysData.matchDays.length - 1],
              );
            }
          }

          _ref.updateWeeklyNavDates(tournamentStartDate);
          _ref.getMatchesData();
          _ref.updateGlobalScheduleUrl();
        }
      },
      _this,
    );
  }

  async yearlyChangeSeason() {
    const _this = this;
    const yearlySeason = _this.filters["yearseason"]?.toLowerCase();
    if (yearlySeason && yearlySeason !== _this.yearlySeason) {
      _this.yearlySeason = yearlySeason;
      await _this.getCompetitionData(yearlySeason);
      _this.getCompetitionLogoData();
    }
  }

  async weeklyNavChangeHandler(fromDate, toDate) {
    const _this = this;
    if (
      !fromDate ||
      !toDate ||
      fromDate.getDate() ===
        _this.weeklyNavDates.currentRangeDates.startDate.getDate()
    ) {
      _this.updateGlobalScheduleUrl();
      return;
    }
    closeCalendar(_this.calendarSelector, _this);
    _this.updateWeeklyNavDates(fromDate);
    _this.updateGlobalScheduleUrl();
    if (
      fromDate > new Date(_this.weeklyNavStartDate) &&
      toDate < new Date(_this.weeklyNavEndDate)
    ) {
      _this.renderMatches();
    } else {
      await Promise.resolve(_this.getMatchesData()).then(
        _this.getCompetitionLogoData(),
      );
    }
  }

  showMatchCardsHandler(parentBody) {
    if (parentBody.hasClass("active")) {
      parentBody.removeClass("active");
    } else {
      parentBody.addClass("active");
    }
  }

  updateWeeklyNavDates(currentDate) {
    if (!currentDate) return;
    const _this = this;
    const weeklyNavDates = getWeeklyNavsDateRangesObj(currentDate);
    if (!weeklyNavDates) return;
    _this.weeklyNavDates = weeklyNavDates;
    //adding metadata
    _this.renderWeeklyNav(
      ".vbw-gs2-weekly-nav-current",
      _this.weeklyNavDates.currentRangeDates?.startDate,
      _this.weeklyNavDates.currentRangeDates?.endDate,
    );
    _this.renderWeeklyNav(
      ".vbw-gs2-weekly-nav-prev",
      _this.weeklyNavDates.prevRangeDates?.startDate,
      _this.weeklyNavDates.prevRangeDates?.endDate,
    );
    _this.renderWeeklyNav(
      ".vbw-gs2-weekly-nav-next",
      _this.weeklyNavDates.nextRangeDates?.startDate,
      _this.weeklyNavDates.nextRangeDates?.endDate,
    );

    _this.searchParamsObj.fromDate =
      _this.weeklyNavDates.currentRangeDates.startDate;
  }

  updateGlobalScheduleUrl() {
    const _this = this;
    if (window.history.pushState) {
      const searchParams = new URLSearchParams(window.location.search);
      for (const param in _this.searchParamsObj) {
        if (param === "fromDate" && !!_this.searchParamsObj[param]) {
          searchParams.set(param, getDateString(_this.searchParamsObj[param]));
        } else if (_this.searchParamsObj[param]) {
          searchParams.set(param, _this.searchParamsObj[param]);
        }
      }
      const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "#" +
        searchParams.toString();
      window.history.pushState({ path: newurl }, "", newurl);
    }
  }

  // Render functions
  renderMatches() {
    const _this = this;
    _this.scrollToTopOnBottomNavClick();

    // return null if no matches received
    if (!_this.model || _this.model.matches?.length === 0) {
      _this.schedulePage
        .find(".vbw-gs2-matches")
        .html(_this.templates.noMatchesFound);
      return;
    }

    // Get matches with valid date in utc
    let allValidMatchArr = _this.model.matches?.filter(
      (match) => !!match.matchDateUtc,
    );

    // Update match date time field to a valid format (sometimes Z found missing in data)
    let allValidMatches = allValidMatchArr?.map((x) => {
      if (x.matchDateUtc.indexOf("Z") === -1)
        x.matchDateUtc = x.matchDateUtc + "Z";
      return x;
    });

    // Get matches for active week date range
    allValidMatches = allValidMatches.filter((match) => {
      let matchDate = new Date(match.matchDateUtc);
      if (match.isMatchTBD) {
        matchDate.setMinutes(
          matchDate.getMinutes() + matchDate.getTimezoneOffset(),
        );
      }
      return (
        matchDate >= _this.weeklyNavDates.currentRangeDates.startDate &&
        matchDate <= _this.weeklyNavDates.currentRangeDates.endDate
      );
    });

    // Get Daily Matches html content
    const [weeklyMatchesContent, filtersData] = getMatchCards(
      allValidMatches,
      _this.model,
      _this.templates,
      _this.isVenueSwitchChecked,
      _this.rankingsData,
    );
    _this.listedCompsWeekly = filtersData.listedComps;
    _this.listedGendersWeekly = filtersData.listedGenders;
    _this.listedDispWeekly = filtersData.listedDisciplines;
    _this.listedTeamWeekly = filtersData.listedTeams;
    _this.listedPoolWeekly = filtersData.listedPools;
    _this.listedRoundWeekly = filtersData.listedRounds;
    _this.listedVenueWeekly = filtersData.listedVenues;

    if (weeklyMatchesContent?.length > 0) {
      _this.schedulePage.find(".vbw-gs2-matches").html(weeklyMatchesContent);
    } else {
      _this.schedulePage
        .find(".vbw-gs2-matches")
        .html(_this.templates.noMatchesFound);
    }

    // Clear old filters
    _this.applyFilters();

    // Render competition filters
    _this.renderAllFilters("weekly");

    // If no competitions present on page
    if (_this.model.allTournaments?.length === 0) return;

    // Render competition logos
    _this.listedCompetitionNos = getCompListString(_this.model.allTournaments);

    // Start polling matches and get live matches data
    if (_this.isFirstLoad) {
      _this.getLiveMatchesData(_this.isFirstLoad);
      _this.pollLiveMatches();
    }
  }

  renderLiveMatches(isFirstLoad) {
    const _this = this;
    if (!_this.liveMatchData || _this.liveMatchData.length === 0) {
      _this.hasLiveMatches = false;
      if (_this.activeTab !== "yearly-tab") {
        _this.pageTabsHandler("weekly-tab");
      }
      return;
    }
    // Get matches list which are live
    const liveMatchList = [];
    _this.liveMatchData?.forEach((data) => {
      const matches = _this.model?.todayMatches?.filter(
        (d) => d.matchNo === data.no && data.status === 1,
      );
      if (!!matches && matches.length > 0) liveMatchList.push(matches[0]);
    });

    // render matches in live section
    if (!!liveMatchList && liveMatchList.length > 0) {
      _this.hasLiveMatches = true;
      // Activate Live Tab as live matches are present and add class
      _this.schedulePage.addClass("has-live-match");

      if (isFirstLoad) {
        _this.pageTabsHandler("live-tab");
      }

      const [liveMatchesContent, filtersData] = getMatchCards(
        liveMatchList,
        _this.model,
        _this.templates,
        false,
        _this.rankingsData,
      );
      _this.listedCompsLive = filtersData.listedComps;
      _this.listedGendersLive = filtersData.listedGenders;
      _this.listedDispLive = filtersData.listedDisciplines;
      _this.listedTeamLive = filtersData.listedTeams;
      _this.listedPoolLive = filtersData.listedPools;
      _this.listedRoundLive = filtersData.listedRounds;
      _this.listedVenueLive = filtersData.listedVenues;

      // Live match related updates
      _this.schedulePage.find(".vbw-gs2-live-matches").html(liveMatchesContent);
      _this.schedulePage
        .find(".vbw-gs2-tab-li .live-match-count")
        .text("(" + liveMatchList?.length + ")");

      // Clear old filters
      _this.applyFilters();

      // Render filters (if condi. to manage polling scenario)
      if (_this.schedulePage.hasClass("live-tab")) {
        _this.renderAllFilters("live");
      }
    } else {
      _this.schedulePage.removeClass("has-live-match");
      _this.hasLiveMatches = false;
      if (isFirstLoad) {
        _this.pageTabsHandler("weekly-tab");
      }
    }

    // update live scores to matches
    _this.liveMatchData?.forEach((data) => {
      _this.schedulePage.find(`[data-match-id="${data.no}"]`).each(function () {
        updateLiveMatch($(this), data);
      });
    });
  }

  renderYearlyCompetitions() {
    const _this = this;
    // return null if no matches received
    if (
      !_this.yearlycompetitions?.competitions ||
      _this.yearlycompetitions?.competitions.length === 0
    ) {
      _this.schedulePage
        .find(".vbw-gs2-calendar")
        .html(_this.templates.noCompetitions);
      return null;
    }

    const [competitionContent, filtersData] = getCompetitionCards(
      _this.yearlycompetitions.competitions,
      _this.templates,
    );
    if (competitionContent?.length > 0) {
      _this.schedulePage.find(".vbw-gs2-calendar").html(competitionContent);
    } else {
      _this.schedulePage
        .find(".vbw-gs2-calendar")
        .html(_this.templates.noCompetitions);
    }
    _this.listedGendersYearly = filtersData.listedGenders;
    _this.listedDisciplinesYearly = filtersData.listedDisciplines;
    _this.listedCompTypeYearly = filtersData.listedCompeTypes;
    _this.listedYearsYearly = _this.yearlycompetitions?.seasons;
    _this.listedYearlyCompetitionNos = getYearlyCompListString(
      _this.yearlycompetitions.competitions,
    );

    // Clear old filters
    _this.applyCompetitionFilters();

    // Render competition filters
    _this.renderAllYearFilters();
    onFilterElemClick(
      $(`.filters-yearseason-ul li[value='${_this.yearlySeason}']`),
      _this,
    );
  }

  scrollToTopOnBottomNavClick() {
    const _this = this;
    if (_this.weeklyNavClicked) {
      const topSection = $(".vbw-gs2-top-section");
      $(window).scrollTop(topSection.offset().top);
    }
    _this.weeklyNavClicked = false;
  }

  renderAllFilters(type = "weekly") {
    const _this = this;

    let compItems = _this.listedCompsWeekly;
    let dispItems = _this.listedDispWeekly;
    let genderItems = _this.listedGendersWeekly;
    let teamItems = _this.listedTeamWeekly;
    let poolItems = _this.listedPoolWeekly;
    let roundItems = _this.listedRoundWeekly;
    let venueItems = _this.listedVenueWeekly;

    if (type === "live") {
      compItems = _this.listedCompsLive;
      dispItems = _this.listedDispLive;
      genderItems = _this.listedGendersLive;
      teamItems = _this.listedTeamLive;
      poolItems = _this.listedPoolLive;
      roundItems = _this.listedRoundLive;
      venueItems = _this.listedVenueLive;
    }

    teamItems?.sort((a, b) => a.localeCompare(b));
    if (this.gsConfig.pools) {
      let pools = this.gsConfig.pools;
      poolItems?.sort(
        (a, b) => pools.indexOf(a.poolName) - pools.indexOf(b.poolName),
      );
    } else {
      poolItems?.sort((a, b) => new Date(a.matchDate) - new Date(b.matchDate));
    }
    poolItems = poolItems.map((_) => _.poolName);
    venueItems?.sort((a, b) => a.localeCompare(b));
    genderItems?.sort((a, b) => a.localeCompare(b));

    _this.renderCompetitionFilter(compItems);
    _this.renderStringsArrFilter(
      genderItems,
      ".vbw-gs2-comp-filters .filters-gender-ul",
    );
    _this.renderDisciplineFilter(dispItems);
    _this.renderStringsArrFilter(
      teamItems,
      ".vbw-gs2-comp-filters .filters-team-ul",
    );
    _this.renderStringsArrFilter(
      poolItems,
      ".vbw-gs2-comp-filters .filters-pool-ul",
    );
    _this.renderStringsArrFilter(
      roundItems,
      ".vbw-gs2-comp-filters .filters-round-ul",
    );
    _this.renderStringsArrFilter(
      venueItems,
      ".vbw-gs2-comp-filters .filters-venue-ul",
    );

    for (const obj in _this.filters) {
      $(`#${obj}.filters-dropdown`)
        .find(`[value='${_this.filters[obj]}']`)
        .trigger("click");
    }
  }

  renderStringsArrFilter(items, selectorElem) {
    if ($(selectorElem).length === 0) return;
    if (!items || items.length === 0) {
      $(selectorElem).parents(".vbw-filters--container").hide();
      return;
    } else {
      $(selectorElem).parents(".vbw-filters--container").show();
    }

    let arrList = [];
    items?.forEach((item) => {
      if (item) {
        const itemTranslated = window.gsConfig.translations[item.toLowerCase()];
        arrList += `<li class="dropdown-li" value="${convertToSlug(item)}">${
          itemTranslated || item
        }</li>`;
      }
    });

    $(selectorElem).find(".dropdown-li").remove();
    $(selectorElem).prepend(arrList);
  }

  renderAllYearFilters() {
    const _this = this;

    _this.listedGendersYearly?.sort((a, b) => a.localeCompare(b));
    _this.listedCompTypeYearly?.sort((a, b) =>
      _this.bptCompType[convertToSlug(a)] > _this.bptCompType[convertToSlug(b)]
        ? 1
        : -1,
    );
    _this.listedYearsYearly?.sort((a, b) => b - a);

    _this.renderStringsArrFilter(
      _this.listedGendersYearly,
      ".vbw-gs2-yearly-filters .filters-yeargender-ul",
    );
    _this.renderStringsArrFilter(
      _this.listedCompTypeYearly,
      ".vbw-gs2-yearly-filters .filters-comptype-ul",
    );
    _this.renderYearlyDisciplineFilter(_this.listedDisciplinesYearly);
    _this.renderYearlyYearFilter(_this.listedYearsYearly);
    _this.renderYearlyMonthFilter(_this.listedMonthsYearly);
  }

  renderCompetitionFilter(items) {
    const _this = this;

    // Check if filter present in view
    if ($(".vbw-gs2-filters-wrap .filters-competitions-ul").length === 0)
      return;

    const compList = [];
    items?.forEach((competition) => {
      const compValue = getCompetitionName(competition);
      _this.templates.compFilterItem
        .find(".vbw-gs2-competitions-li")
        .attr("value", convertToSlug(compValue));
      _this.templates.compFilterItem
        .find(".vbw-comp-li-img")
        .attr("data-comp-square-logo", competition?.no);
      _this.templates.compFilterItem
        .find(".vbw-comp-li-img")
        .attr("alt", competition?.name);
      _this.templates.compFilterItem.find(".vbw-comp-li-img").attr("src", "");
      _this.templates.compFilterItem
        .find(".vbw-comp-li-discipline")
        .html($(`.vbw-template-discipline-${competition?.discipline}`).html());
      _this.templates.compFilterItem.find(".vbw-comp-li-name").text(compValue);
      compList.push(_this.templates.compFilterItem.html());
    });

    $(".vbw-gs2-filters-wrap .filters-competitions-ul")
      .find(".vbw-gs2-competitions-li")
      .remove();
    $(".vbw-gs2-filters-wrap .filters-competitions-ul").prepend(compList);
    renderCompetitionLogo(_this.competitionLogos);
  }

  renderDisciplineFilter(items) {
    const _this = this;

    // Check if filter present in view
    if ($(".vbw-gs2-comp-filters .filters-discipline-ul").length === 0) return;

    let disciplineList = [];
    items?.forEach((item) => {
      if (item)
        disciplineList += `<li class="dropdown-li" value="${
          item?.discipline
        }">${_this.gsConfig.translations[item?.discipline]}</li>`;
    });

    $(".vbw-gs2-comp-filters .filters-discipline-ul")
      .find(".dropdown-li")
      .remove();
    $(".vbw-gs2-comp-filters .filters-discipline-ul").prepend(disciplineList);
  }

  renderYearlyDisciplineFilter(items) {
    const _this = this;

    // Check if filter present in view
    if ($(".vbw-gs2-yearly-filters .filters-yeardiscipline-ul").length === 0)
      return;

    let disciplineList = [];
    items?.forEach((item) => {
      if (item)
        disciplineList += `<li class="dropdown-li" value="${item}">${_this.gsConfig.translations[item]}</li>`;
    });

    $(".vbw-gs2-yearly-filters .filters-yeardiscipline-ul")
      .find(".dropdown-li")
      .remove();
    $(".vbw-gs2-yearly-filters .filters-yeardiscipline-ul").prepend(
      disciplineList,
    );
  }

  renderYearlyMonthFilter(items) {
    const _this = this;
    // Check if filter present in view
    if ($(".vbw-gs2-yearly-filters .filters-yearmonth-ul").length === 0) return;

    let monthList = [];
    for (const item of items) {
      monthList += `<li class="dropdown-li" value="${item}">${_this.gsConfig.translations.months[item]}</li>`;
    }

    $(".vbw-gs2-yearly-filters .filters-yearmonth-ul")
      .find(".dropdown-li")
      .remove();
    $(".vbw-gs2-yearly-filters .filters-yearmonth-ul").prepend(monthList);
  }

  renderYearlyYearFilter(items) {
    // Check if filter present in view
    if ($(".vbw-gs2-yearly-filters .filters-yearseason-ul").length === 0)
      return;

    let yearList = [];
    items?.forEach((item) => {
      if (item)
        yearList += `<li class="dropdown-li" value="${item}">${item}</li>`;
    });

    $(".vbw-gs2-yearly-filters .filters-yearseason-ul")
      .find(".dropdown-li")
      .remove();
    $(".vbw-gs2-yearly-filters .filters-yearseason-ul").prepend(yearList);
  }

  renderWeeklyNav(navSelector, fromDate, toDate) {
    const _this = this;
    const weeklyNav = _this.schedulePage.find(navSelector);
    const toDateStr = getDateString(toDate);
    const toDateFullStr = toDateStr + "T12:00:00Z";
    const fromDateStr = getDateString(fromDate);
    const fromDateFullStr = fromDateStr + "T12:00:00Z";
    weeklyNav.attr("data-weekly-from-date-full", fromDateFullStr);
    weeklyNav.attr("data-weekly-from-date", fromDateStr);
    weeklyNav.attr("data-weekly-to-date-full", toDateFullStr);
    weeklyNav.attr("data-weekly-to-date", toDateStr);
    const weeklyNavHeadText = getWeeklyNavDateString(fromDate, toDate);
    weeklyNav.find(".weekly-nav-head-text").text(weeklyNavHeadText);
  }

  // Data Collectors
  getMatchesData() {
    const _this = this;
    const [fromDate, toDate] = getGlobalScheduleApiDateRange(
      _this.weeklyNavDates,
    );
    const matchesApi = _this.gsConfig.matchesApi
      ?.replace("{fromDate}", fromDate)
      .replace("{toDate}", toDate)
      .replace("{volleyTournamentIDs}", _this.gsConfig.volleyTournamentIDs)
      .replace("{beachTournamentIDs}", _this.gsConfig.beachTournamentIDs);
    showLoading(_this.schedulePage, _this.templates.loadingMatches);

    return $.ajax({
      headers: {
        "Content-Type": "application/json",
      },
      type: "GET",
      url: matchesApi,
    })
      .done(function (data) {
        _this.model = data;
        _this.weeklyNavStartDate = fromDate;
        _this.weeklyNavEndDate = toDate;
        hideLoading(_this.schedulePage);
        _this.rankingsData = [
          ...(_this.model.worldRanking?.futureWorldRanking?.l_Tournaments
            ? _this.model.worldRanking.futureWorldRanking.l_Tournaments
            : []),
          ...(_this.model.worldRanking?.pastWorldRanking?.l_Tournaments
            ? _this.model.worldRanking.pastWorldRanking.l_Tournaments
            : []),
        ];
        _this.renderMatches();
        _this.stickyHeaders.init();
      })
      .fail(function (err) {
        hideLoading(_this.schedulePage);
        console.log("Matches Api err: ", err);
      });
  }

  getLiveMatchesData(isFirstLoad = false) {
    const _this = this;

    let fromDate = new Date();
    let toDate = new Date();
    fromDate.setDate(fromDate.getDate() - 1);
    toDate.setDate(toDate.getDate() + 1);

    fromDate = getDateString(fromDate);
    toDate = getDateString(toDate);

    $.when(
      $.ajax({
        type: "GET",
        url: _this.gsConfig.liveApi
          ?.replace("{matches}", _this.liveTypes[0])
          .replace("{tournaments}", _this.listedCompetitionNos)
          .replace("{fromDate}", fromDate)
          .replace("{toDate}", toDate),
      }),
      $.ajax({
        type: "GET",
        url: _this.gsConfig.liveApi
          ?.replace("{matches}", _this.liveTypes[1])
          .replace("{tournaments}", _this.listedCompetitionNos)
          .replace("{fromDate}", fromDate)
          .replace("{toDate}", toDate),
      }),
    ).then(function (d1, d2) {
      _this.liveMatchData = [...d1[0], ...d2[0]];
      _this.renderLiveMatches(isFirstLoad);
      _this.isFirstLoad = false;
    });
  }

  getCompetitionData(seasonYear) {
    const _this = this;
    const competitionApi = _this.gsConfig.competitionApi
      ?.replace("{year}", seasonYear)
      .replace("{month}", "");
    showLoading(
      _this.schedulePage,
      _this.templates.loadingCompetitions,
      ".vbw-gs2-calendar",
    );

    return $.ajax({
      headers: {
        "Content-Type": "application/json",
      },
      type: "GET",
      url: competitionApi,
    })
      .done(function (data) {
        _this.yearlycompetitions = data;
        hideLoading(_this.schedulePage, ".vbw-gs2-calendar");
        _this.renderYearlyCompetitions();
      })
      .fail(function (err) {
        hideLoading(_this.schedulePage, ".vbw-gs2-calendar");
        console.log("Competition Api err: ", err);
      });
  }

  pollLiveMatches() {
    const _this = this;
    const pollTime = _this.gsConfig.livePollingTimeMs
      ? _this.gsConfig.livePollingTimeMs
      : 30000;

    setInterval(function () {
      _this.getLiveMatchesData();
    }, pollTime);
  }

  getCompetitionLogoData(listedCompetitionNos) {
    const _this = this;
    if (!listedCompetitionNos) {
      listedCompetitionNos =
        _this.listedCompetitionNos + ";" + _this.listedYearlyCompetitionNos;
    }

    $.ajax({
      headers: {
        "Content-Type": "application/json",
      },
      type: "GET",
      cache: true,
      url: _this.gsConfig.tournamentLogoApi + listedCompetitionNos,
    })
      .done(function (data) {
        _this.competitionLogos = data;
        renderCompetitionLogo(_this.competitionLogos);
      })
      .fail(function (err) {
        console.log("Tournament Logo Api err: ", err);
      });
  }

  // Filter functions
  applyFilters() {
    const _this = this;
    const items = $(".vbw-gs2-match-item");
    const compItems = $(".vbw-gs2-comp-row");
    const gender = _this.filters["gender"]?.toLowerCase();
    const discipline = _this.filters["discipline"]?.toLowerCase();
    const team = _this.filters["team"]?.toLowerCase();
    const competition = _this.filters["competition"]?.toLowerCase();
    const pool = _this.filters["pool"]?.toLowerCase();
    const round = _this.filters["round"]?.toLowerCase();
    const venue = _this.filters["venue"]?.toLowerCase();

    _this.resetFilter(items);
    _this.filter(items, {
      gender,
      discipline,
      team,
      compItems,
      competition,
      pool,
      round,
      venue,
    });
    _this.hideEmptyCompetitions();
  }

  applyCompetitionFilters() {
    const _this = this;
    const items = $(".vbw-gs2-comp-card");
    const gender = _this.filters["yeargender"]?.toLowerCase();
    const discipline = _this.filters["yeardiscipline"]?.toLowerCase();
    const month = _this.filters["yearmonth"]?.toLowerCase();
    const comptype = _this.filters["comptype"]?.toLowerCase();

    _this.resetFilter(items);
    _this.filterCompetition(items, {
      gender,
      discipline,
      month,
      comptype,
    });
    _this.hideEmptyStatus();
  }

  resetFilter(items) {
    for (const item of items) {
      $(item).removeClass("hidden");
    }
  }

  filter(items, filterData) {
    const _this = this;
    items.each((index, item) => {
      const $item = $(item);
      if (_this.shouldHideMatch($item, filterData)) {
        $item.addClass("hidden");
      }
    });

    filterData.compItems.each((index, comp) => {
      const $comp = $(comp);
      if (_this.hideCompetitionItem($comp, filterData.competition)) {
        $comp.find(".vbw-gs2-match-item").addClass("hidden");
      }
    });

    // Show empty message if no matches in view
    _this.handleFilterMessage();
  }

  shouldHideMatch($item, filterData) {
    const g = $item.attr("data-gender");
    const d = $item.attr("data-discipline")?.toLowerCase();
    const t = $item.attr("data-country");
    const p = $item.attr("data-pool");
    const r = $item.attr("data-round");
    const v = $item.attr("data-venue");

    return (
      (filterData.gender && filterData.gender !== g) ||
      (filterData.team && t.indexOf(filterData.team) === -1) ||
      (filterData.discipline && filterData.discipline !== d) ||
      (filterData.pool && filterData.pool !== p) ||
      (filterData.round && filterData.round !== r) ||
      (filterData.venue && filterData.venue !== v)
    );
  }

  hideCompetitionItem($comp, competition) {
    const c = $comp.attr("data-tournament-name").toLowerCase();
    return competition && c !== competition;
  }

  filterCompetition(items, filterData) {
    const _this = this;
    for (const item of items) {
      const $item = $(item);
      const attributes = _this.getFilterAttributes($item);
      if (_this.shouldHideCompetition(filterData, attributes)) {
        $item.addClass("hidden");
      }
    }

    // Show empty message if no matches in view
    _this.handleYearlyFilterMessage();
  }

  shouldHideCompetition(filterData, attributes) {
    const filterHas = [];
    if (filterData.gender && !attributes.gender.includes(filterData.gender))
      filterHas.push("1");
    if (
      filterData.discipline &&
      filterData.discipline !== attributes.discipline
    )
      filterHas.push("1");
    if (filterData.month && !attributes.month.includes(filterData.month))
      filterHas.push("1");
    if (filterData.comptype && filterData.comptype !== attributes.comptype)
      filterHas.push("1");
    return filterHas.length > 0 && filterHas.includes("1");
  }

  getFilterAttributes($item) {
    return {
      gender: $item.attr("data-gender")?.toLowerCase()?.split(","),
      discipline: $item.attr("data-discipline")?.toLowerCase(),
      month: $item.attr("data-month")?.split(","),
      comptype: $item.attr("data-comptype")?.toLowerCase(),
    };
  }

  hideEmptyCompetitions() {
    // Hide empty competition rows
    $(".vbw-gs2-comp-row").each(function () {
      if ($(this).find(".vbw-gs2-match-item").not(".hidden").length === 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });

    // Hide empty date rows
    $(".vbw-gs2-date-row").each(function () {
      if ($(this).find(".vbw-gs2-match-item").not(".hidden").length === 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  }

  hideEmptyStatus() {
    // Hide empty competition rows
    $(".vbw-gs2-status-row").each(function () {
      if ($(this).find(".vbw-gs2-comp-card").not(".hidden").length === 0) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  }

  handleFilterMessage() {
    const _this = this;
    const selector =
      _this.activeTab === "live-tab"
        ? ".vbw-gs2-live-matches"
        : ".vbw-gs2-matches";
    if (
      _this.schedulePage.find(`${selector} .vbw-gs2-match-item`).length !== 0 &&
      _this.schedulePage.find(`${selector} .vbw-gs2-match-item`).not(".hidden")
        .length === 0
    ) {
      _this.schedulePage
        .find(selector)
        .append(_this.templates.noFilterMatchesFound);
      _this.schedulePage.find(`${selector} .vbw-gs2-result-msg`).remove();
    } else {
      _this.schedulePage.find(`${selector} .vbw-gs2-filter-msg`).remove();
    }
  }

  handleYearlyFilterMessage() {
    const _this = this;
    const selector = ".vbw-gs2-calendar";
    if (
      _this.schedulePage.find(`${selector} .vbw-gs2-comp-card`).length !== 0 &&
      _this.schedulePage.find(`${selector} .vbw-gs2-comp-card`).not(".hidden")
        .length === 0
    ) {
      _this.schedulePage.find(selector).append(_this.templates.noCompetitions);
    } else {
      _this.schedulePage.find(`${selector} .vbw-gs2-competition-msg`).remove();
    }
  }
}

(async function classInit() {
  await GlobalScheduleV2Page.asyncInit();
})();
